if (!customElements.get('product-sticky')) {
  customElements.define(
    'product-sticky',
    class ProductSticky extends HTMLElement {
      constructor() {
        super();
        this.productSubmitButton = document.querySelector('.product-form__submit');
        this.productQuantityInput = document.querySelector('.product .quantity__input');
        if (this.productQuantityInput) {
          this.quantityInput = document.querySelector('.product-sticky__quantity .quantity__input');
          this.button = this.querySelector('.product-sticky__button');

          this.productQuantityInput.addEventListener('change', this.handleProductQuantityChange.bind(this));
          this.quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
          this.button.addEventListener('click', this.handleButtonClick.bind(this));
          document.addEventListener('scroll', this.handleScroll.bind(this));

          this.handleScroll();
        }
      }

      handleProductQuantityChange(evt) {
        this.quantityInput.value = evt.target.value;
      }

      handleQuantityChange(evt) {
        evt.preventDefault();
        this.productQuantityInput.value = evt.target.value;
        this.productQuantityInput.dispatchEvent(new Event('change'));
      }

      handleButtonClick(evt) {
        evt.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', true);
        this.button.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        this.productSubmitButton.click();

        setTimeout(() => {
          this.button.setAttribute('aria-disabled', false);
          this.button.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }, 1500);
      }

      handleScroll() {
        if (
          this.elementInViewport(this.productSubmitButton) ||
          this.elementInViewport(document.querySelector('.footer__content-bottom '))
        ) {
          this.classList.remove('product-sticky--active');
        } else {
          this.classList.add('product-sticky--active');
        }
      }

      elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
          el = el.offsetParent;
          top += el.offsetTop;
          left += el.offsetLeft;
        }

        return (
          top >= window.pageYOffset &&
          left >= window.pageXOffset &&
          top + height <= window.pageYOffset + window.innerHeight &&
          left + width <= window.pageXOffset + window.innerWidth
        );
      }
    }
  );
}
